<script setup>
import { useFutureStore } from '~/store/future'
import xSelect from '@/components/common/xSelect.vue'
import { useUserStore } from '~/store/user'

const { t, locale } = useI18n()
const router = useRouter()
const route = useRoute()
const user = useUserStore()
const future = useFutureStore()
const marginType = ref(1)
const AdjustLeverage = defineAsyncComponent(() => import('../modal/AdjustLeverage.vue'))
const list = computed(() => [
  { label: t('逐仓'), key: 2, disabled: future.isBonus },
  { label: t('全仓'), key: 1 },
])
function setMarginType(type) {
  future.setPositionConfig({ isolated: type === 2 })
}
function handleBar() {
  if (!user.isLogin) {
    router.push({
      path: `/${locale.value}/log-in`,
      query: { ...route.query, backUrl: encodeURIComponent(location.href) },
    })
  }
}
watch(() => future.positionConfig, (nv) => {
  marginType.value = nv.marginType
}, {
  immediate: true,
})
</script>

<template>
  <div class="flex items-center h-8">
    <div class="cursor-pointer" @click="handleBar">
      <div class="flex items-center h-8 px-4 space-x-4 rtl:space-x-reverse font-medium" :class="{ 'pointer-events-none': !user.isLogin }">
        <xSelect v-model="marginType" class="!ms-0" left list-class="whitespace-nowrap" :list="list" @select="setMarginType" />
        <div id="driverFuturesGrantsLeverage" class="text-xs text-buy" @click="future.showModal('adjustLeverage')">
          {{ `${$t('杠杆')} ${future.positionConfig.leverage}X` }}
        </div>
      </div>
    </div>
    <AdjustLeverage v-model:show="future.modal.adjustLeverage" />
  </div>
</template>
